angular.module('unica_notification.notification_services')

.factory('NotificationCreateService', function($http, getBaseApiURL) {

	var notificationCreateService = {};

	notificationCreateService.create = function( eventId, notificationData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/create/' + eventId,
			data: notificationData
		}).then(function(result) {

			if ( result ) {
				return result.data.notificationGroup;
			}

		});
	};

	return notificationCreateService;

});